
import { Button, FloatingLabel, Form } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import FlexCenter from './FlexCenter';
import useDomicilioFiscal from '../hooks/useDomicilioFiscal';
import ModalDomicilioFiscal from './ModalDomicilioFiscal';

const DomicilioFiscal = () => {

    const { guardarDomicilio, formDomicilioFiscal, setFormDomicilioFiscal, cargando } = useDomicilioFiscal();

    return (
        <div className='mt-4'>
            <p className="lead text-center">
                Domicilio fiscal
            </p>
            <ModalDomicilioFiscal/>
            <Row>
                <Col xs={12} xl={6}>
                    <FloatingLabel controlId='floatingSelect' label='Código Postal' className='mb-3'>
                        <Form.Control
                            placeholder=' '
                            autoComplete='off'
                            value={ formDomicilioFiscal.codigo_postal || "" }
                            onChange={ (e) => setFormDomicilioFiscal({ ...formDomicilioFiscal, codigo_postal: e.target.value }) }
                        />
                    </FloatingLabel>
                </Col>
                <Col xs={12} xl={6}>
                    <FloatingLabel controlId='floatingInput1' label='Código fiscal' className='mb-3'>
                        <Form.Control
                            placeholder=' '
                            autoComplete='off'
                            value={ formDomicilioFiscal.codigo_fiscal || "" }
                            onChange={ (e) => setFormDomicilioFiscal({ ...formDomicilioFiscal, codigo_fiscal: e.target.value }) }
                        />
                    </FloatingLabel>
                </Col>
                <Col xs={12} xl={6}>
                    <FloatingLabel controlId='floatingInput1' label='Tipo de vialidad' className='mb-3'>
                        <Form.Control
                            placeholder=' '
                            autoComplete='off'
                            value={ formDomicilioFiscal.tipo_vialidad || "" }
                            onChange={ (e) => setFormDomicilioFiscal({ ...formDomicilioFiscal, tipo_vialidad: e.target.value }) }
                        />
                    </FloatingLabel>
                </Col>
                <Col xs={12} xl={6}>
                    <FloatingLabel controlId='floatingInput1' label='Nombre de vialidad' className='mb-3'>
                        <Form.Control
                            placeholder=' '
                            autoComplete='off'
                            value={ formDomicilioFiscal.nombre_vialidad || "" }
                            onChange={ (e) => setFormDomicilioFiscal({ ...formDomicilioFiscal, nombre_vialidad: e.target.value }) }
                        />
                    </FloatingLabel>
                </Col>
                <Col xs={12} xl={6}>
                    <FloatingLabel controlId='floatingInput1' label='Número exterior' className='mb-3'>
                        <Form.Control
                            placeholder=' '
                            autoComplete='off'
                            value={ formDomicilioFiscal.numero_exterior || "" }
                            onChange={ (e) => setFormDomicilioFiscal({ ...formDomicilioFiscal, numero_exterior: e.target.value }) }
                        />
                    </FloatingLabel>
                </Col>
                <Col xs={12} xl={6}>
                    <FloatingLabel controlId='floatingInput1' label='Número interior' className='mb-3'>
                        <Form.Control
                            placeholder=' '
                            autoComplete='off'
                            value={ formDomicilioFiscal.numero_interior || "" }
                            onChange={ (e) => setFormDomicilioFiscal({ ...formDomicilioFiscal, numero_interior: e.target.value }) }
                        />
                    </FloatingLabel>
                </Col>
                <Col xs={12} xl={6}>
                    <FloatingLabel controlId='floatingInput1' label='Nombre de la colonia' className='mb-3'>
                        <Form.Control
                            placeholder=' '
                            autoComplete='off'
                            value={ formDomicilioFiscal.nombre_colonia || "" }
                            onChange={ (e) => setFormDomicilioFiscal({ ...formDomicilioFiscal, nombre_colonia: e.target.value }) }
                        />
                    </FloatingLabel>
                </Col>
                <Col xs={12} xl={6}>
                    <FloatingLabel controlId='floatingInput1' label='Nombre de la localidad' className='mb-3'>
                        <Form.Control
                            placeholder=' '
                            autoComplete='off'
                            value={ formDomicilioFiscal.nombre_localidad || "" }
                            onChange={ (e) => setFormDomicilioFiscal({ ...formDomicilioFiscal, nombre_localidad: e.target.value }) }
                        />
                    </FloatingLabel>
                </Col>
                <Col xs={12} xl={6}>
                    <FloatingLabel controlId='floatingInput1' label='Municipio o demarcación territorial' className='mb-3'>
                        <Form.Control
                            placeholder=' '
                            autoComplete='off'
                            value={ formDomicilioFiscal.municipio || "" }
                            onChange={ (e) => setFormDomicilioFiscal({ ...formDomicilioFiscal, municipio: e.target.value }) }
                        />
                    </FloatingLabel>
                </Col>
            </Row>

            <FlexCenter>
                <Button onClick={ guardarDomicilio } disabled={ cargando }>
                    { ( cargando ) ? "Guardando" : "Guardar cambios" }
                </Button>
            </FlexCenter>

            <hr className='m-5'/>
        </div>
    )
}

export default DomicilioFiscal
